import produce from 'immer';

import {
  SET_PROJECTS,
  SET_PROJECT,
  SET_PROJECT_ID,
  SET_SUBMITTED_PROJECT,
  SET_PROJECT_RESPONDENT_TABLE_REFRESH,
} from './actionTypes';

export const initialState = {
  projects: null,
  project: null,
  projectId: null,
  submittedProject: null,
  refreshProjectRespondentsTable: false,
};

/* eslint-disable default-case */
const projectReducer = (state = initialState, { type, payload }) =>
  produce(state, (draft) => {
    switch (type) {
      case SET_PROJECTS:
        draft.projects = payload;
        break;
      case SET_PROJECT:
        draft.project = payload;
        break;
      case SET_PROJECT_ID:
        draft.projectId = payload;
        break;
      case SET_SUBMITTED_PROJECT:
        draft.submittedProject = payload;
        break;
      case SET_PROJECT_RESPONDENT_TABLE_REFRESH:
        draft.refreshProjectRespondentsTable = payload;
        break;
    }
  });

export default projectReducer;
